import Hlsjs from 'hls.js';
import videojs from 'video.js';

/**
 * Кастомный загрузчик для плейлистов Noxbit.
 *
 * Дон Аристарх, [14.04.17 15:22]
 * [In reply to Kot]
 * Тогда нам наверное надо придти к соглашению по формированию урл. Меня устройит :
 * GET /hls?cid=87 - при старте проигрывания
 * GET /hls?cid=87?sid=<sid> при запросе всех последующих чанков
 */
class HlsjsNoxbitPlaylistLoader extends Hlsjs.DefaultConfig.loader {
  load(context, config, callbacks) {
    if (this.isNoxbitPlaylist(context.url)) {
      const currentCid = this.getNoxbitCid(context.url);
      if (HlsjsNoxbitPlaylistLoader.cid !== currentCid) {
        HlsjsNoxbitPlaylistLoader.cid = currentCid;
        HlsjsNoxbitPlaylistLoader.sid = Math.floor(Math.random() * (Math.pow(2, 32) - 1));
      } else {
        context.url += '&sid=' + HlsjsNoxbitPlaylistLoader.sid;
      }
    }
    return super.load(context, config, callbacks);
  }

  /**
   * Проверяет принадлежность ссылки на плейлист движку Noxbit.
   *
   * @param {string} url
   * @returns {boolean}
   */
  isNoxbitPlaylist(url) {
    return /:6689\/hls\b/.test(url);
  }

  /**
   * Возвращает cid из ссылки на плейлист Noxbit.
   *
   * @param {string} url
   * @returns {string|null}
   */
  getNoxbitCid(url) {
    return (/\bcid=(\d+)/.exec(url) || [, null])[1];
  }
}

// Установим этот загрузчик по умолчанию
videojs.options.html5.hlsjs = videojs.options.html5.hlsjs || {};
videojs.options.html5.hlsjs.pLoader = HlsjsNoxbitPlaylistLoader;

videojs.registerComponent('HlsjsNoxbitPlaylistLoader', HlsjsNoxbitPlaylistLoader);
export default HlsjsNoxbitPlaylistLoader;



// WEBPACK FOOTER //
// ./src/components/hlsjs-noxbit-playlist-loader.js